import { render, staticRenderFns } from "./TagsCard.vue?vue&type=template&id=1430455f&"
import script from "./TagsCard.vue?vue&type=script&lang=js&"
export * from "./TagsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports